<template>

  <div>

    <v-dialog v-model="show_dialog_ref" max-width="70%">


      <v-card>
        <v-card-title>
          What is Cancer
        </v-card-title>
        <v-card-text>


          <p>
            The U.S. Preventive Services Task Force recommends those 50 - 75 undergo regular screening.
            Note, however, that the American Cancer Society recently changed their recommended guidelines to include
            those 45 and above.
          </p>




          Source: US Centers for Disease Control and Prevention (CDC)<br>
          <a href="https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm"
             target="_blank">
            https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm
          </a>

          <br>
          Source: American Cancer Society <br>
          <a href="https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html"
             target="_blank">
            https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html
          </a>

        </v-card-text>

      </v-card>


    </v-dialog>












    <v-card max-width="900px">
      <v-card-title >
        Constipation
      </v-card-title>
      <v-card-text  class="content-text my-content">

        <div class="title">
          What Is It
        </div>

        <p>
          Constipation is when you have too few bowel movements.  In most cases it is not serious and can be alleviated
          by simply drinking enough fluids and eating a high fiber diet.
        </p>




        <div class="title">
          Symptoms
        </div>

        <p>
          Different individuals have different bowel habits determining so you need to take into account your
          <span style="font-style: italic">normal</span> bowel pattern before judging if you are constipated.
          In general, however, here are some guidelines:
        </p>

        <ul>
          <li>You're having less than 3 bowel movements a week</li>
          <li>Trouble having a bowel movement (straining to go)</li>
          <li>Hard stool</li>
          <li>Small stool</li>
          <li>A sense that everything did not come out</li>
          <li>Bloated sensation</li>
        </ul>




        <div class="title">
          Causes
        </div>

        <p>There are a number of reason why you might be experiencing constipation.  Some of the more common ones are:</p>

        <ul>
          <li>Medications such as iron, narcotic pain meds, and antidepressants</li>
          <li>Not enough water or fiber in the diet</li>
          <li>Irritable bowel syndrome with constipation</li>
          <li>Hypothyroidism (underactive thyroid)</li>
          <li>Not enough physical activity</li>
          <li>Over use of laxative</li>
          <li>Colon cancer</li>
          <li>Pregnancy</li>
          <li>Stress</li>



        </ul>




        <div class="title">
          Treatments
        </div>

        <p>
          One of the most important things that can help avoid constipation is drinking 6-8 glasses of water a day.
          In particular, try drinking warm liquid in the morning.
          Eating a well-balanced diet high in fiber (fruits, vegetables, legume, whole grain bread, cereal) can also
          reducing the likelihood of being constipated.  Also try avoid dairy products as they can cause
          constipation in some individuals.

        </p>

        <p>
          Exercise also can help. Try exercising 30 min a day, 3 times a week.
          And finally, make sure to go to the bathroom when you feel the urge.  Holding it in can cause
          constipation.
        </p>


        <div class="title">
          When To Call A Doctor
        </div>


        <p>
          In most cases, constipation doesn't require professional intervention.  However, if you experience the following
          together with constipation, seek medical advice:
        </p>

        <ul>
          <li>Sudden onset of constipation with abdominal pain and cramps</li>
          <li>Not able to defecate or pass gas at all</li>
          <li>New onset of constipation</li>
          <li>Blood in the stool</li>
          <li>Unintentional weight loss</li>
          <li>Severe abdominal pain without a bowel movement</li>
          <li>A dramatic change in the shape, size, and consistency of stool</li>
        </ul>

        <div class="title">
          References
        </div>
        <refs  :refs="bib"></refs>
      </v-card-text>

    </v-card>
  </div>




</template>





<style scoped lang="scss">
  @use 'contentStyles';

</style>


<script>
// @ is an alias to /src
import refs from '@/components/references.vue';
import utilities from '@/mixins/utilities.js';


export default {
   mixins: [utilities],
   components: {refs},
   data(){return {

      show_dialog_ref: false,
      bib: [
         {
            raw: 'American Gastroenterological Association, Bharucha AE, Dorn SD, Lembo A, Pressman A. American Gastroenterological Association medical position statement on constipation. Gastroenterology. 2013;144(1):211–217.',
            ref: 'stats',
         },
         // {
         //    raw: 'Brown, S R et al. “Effect of coffee on distal colon function.” Gut vol. 31,4 (1990): 450-3. doi:10.1136/gut.31.4.450',
         //    url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1378422/',
         //    ref: 'coffee',
         // },
         {

            url: 'https://www.niddk.nih.gov/health-information/digestive-diseases/constipation/symptoms-causes',
            ref: '',
         },
      ]
   }},



   methods:{
      getr(ref){
         return (this.findWithAttr(this.bib, 'ref', ref)+1).toString();
      }
   },

   created(){

      this.sort_bib_list(this.bib);
   }



}
</script>
